module.exports = __webpack_public_path__ + "static/media/arrows_icon.838cb654.svg";